import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ErrorPage() {
  return (
    <div className="min-h-screen bg-primary-50 flex items-center justify-center px-6 relative overflow-hidden">
      {/* === BACKGROUND SHAPES === */}
      <div className="absolute -right-40 top-0 w-[400px] h-[400px] opacity-[0.5] z-0">
        <HalfCircle color="#672178" />
      </div>

      <div className="absolute -left-40 bottom-0 w-[480px] h-[480px] opacity-[0.14] z-0">
        <HalfCircle color="#ffcc00" />
      </div>

      {/* === CONTENT === */}
      <div className="relative z-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-md"
        >
          {/* ICON */}
          <motion.div
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="flex justify-center mb-6"
          >
            <AlertTriangle className="w-20 h-20 text-accent" />
          </motion.div>

          {/* TITLE */}
          <h1 className="text-6xl font-extrabold text-accent-500 mb-3">404</h1>

          <p className="text-lg text-accent-700 mb-8">
            Halaman yang Anda cari tidak ditemukan atau telah dipindahkan.
          </p>

          {/* BUTTON */}
          <Link
            to="/"
            className="
              inline-block 
              bg-primary-700 text-white 
              px-6 py-3 rounded-xl 
              font-semibold shadow-lg 
              hover:bg-primary-800 transition-all
            "
          >
            Kembali ke Beranda
          </Link>
        </motion.div>
      </div>
    </div>
  );
}

function HalfCircle({ color }) {
  return (
    <svg viewBox="0 0 200 200" fill="none">
      <circle cx="100" cy="100" r="100" fill={color} />
    </svg>
  );
}
